import Modal from 'react-responsive-modal';
import styles from './style.module.css';

interface ModalConfirmFinishTrailProps {
  modalIsOpen: boolean;
  toggleModal: () => void;
  onConfirm: () => void;
}

export function ModalConfirmFinishTrail({
  modalIsOpen,
  toggleModal,
  onConfirm,
}: ModalConfirmFinishTrailProps) {
  return (
    <Modal open={modalIsOpen} onClose={toggleModal} center>
      <div className={styles.contents}>
        <h2 className={styles.title}>ATENÇÃO</h2>
        <p className={styles.detail}>
          Garanta que você atingiu o desempenho mínimo na trilha!
        </p>
        <p className={styles.detail}>
          Após finalizar, você NÃO poderá voltar a tentar responder novamente.
        </p>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
            onConfirm();
          }}
          className={styles.btnBack}
          type="button"
        >
          Finalizar
        </button>
        <button onClick={toggleModal} className={styles.btnAgree} type="button">
          Cancelar
        </button>
      </div>
    </Modal>
  );
}
